import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id CC669D6C-53AD-43C2-A660-EFF783847D6F
 * name format-header-4
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-4.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeader4Icon = createSvgIcon(<><path d="M3,4H5V10H9V4H11V18H9V12H5V18H3V4M18,18V13H13V11L18,4H20V11H21V13H20V18H18M18,11V7.42L15.45,11H18Z" /></>, 'FormatHeader4Icon');
export default FormatHeader4Icon